import styled from 'styled-components';
import { Barlow, Gilroy } from './../index';
import { Blue, White } from '../../colors';
import { TitleSize, AmountSize, CurrencySize, TitleLineHeight, AmountLineHeight } from './constants/Sizes';
export const LoanAmountContainer = styled.div `
  display: flex;
  flex-direction: column;
`;
export const Title = styled(Barlow) `
  color: ${({ size }) => size ? White.normal : Blue.dark};
  font-size: ${({ size }) => size ? TitleSize[size] : TitleSize.Small};
  line-height: ${({ size }) => size ? TitleLineHeight[size] : TitleLineHeight.Small};
`;
export const Amount = styled(Gilroy) `
	color: ${({ size }) => size ? White.normal : Blue.dark};
  font-size:${({ size }) => size ? AmountSize[size] : AmountSize.Small};
  font-weight: bold;
  line-height: ${({ size }) => size ? AmountLineHeight[size] : AmountLineHeight.Small};
`;
export const Currency = styled(Gilroy) `
  font-size:${({ size }) => size ? CurrencySize[size] : CurrencySize.Small};
`;
//# sourceMappingURL=LoanAmount.Styled.js.map